export class TestsIstructions {
    Id:number[];
    TestId:number;
    Active:number;
    LookupId:number[];
}